import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影频道", to: "/category/电影" },
  { label: "电视剧频道", to: "/category/电视剧" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

const typeLinks = [
  { label: "科幻", to: "/category/电影/科幻" },
  { label: "悬疑", to: "/category/电影/悬疑" },
  { label: "古装", to: "/category/电视剧/古装" },
  { label: "都市", to: "/category/电视剧/都市" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-site px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-clapperboard-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-background-50">秋霞影视</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              秋霞影视致力于为广大影视爱好者提供丰富的电影、电视剧资料与最新影视资讯。
              在这里，你可以轻松浏览分类、筛选心仪作品，并第一时间获取影视动态。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-600 tracking-wide text-background-50">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-100/70 transition-colors hover:text-accent-400">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-600 tracking-wide text-background-50">热门类型</h4>
            <ul className="space-y-2.5">
              {typeLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-100/70 transition-colors hover:text-accent-400">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-100/10 pt-6">
          <div className="flex flex-col gap-3 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2025 秋霞影视 版权所有 · 本站影视资料仅供演示展示，不提供在线播放</p>
            <p className="flex items-center gap-2">
              <i className="ri-shield-check-line" aria-hidden="true"></i>
              友情链接：影视资讯 · 观影指南 · 电影资料库
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}